if (!customElements.get('desktop-menu-hover')) {
  customElements.define('desktop-menu-hover', class extends HTMLElement {
    #closeTimeout = null;

    connectedCallback() {
      this.menuItems = this.querySelectorAll('[data-desktop-menu-item]');

      this.menuItems.forEach(item => {
        const trigger = item.querySelector('[data-desktop-menu-trigger]');
        const content = trigger.nextElementSibling;

        trigger.addEventListener('mouseenter', () => {
          this.#cancelClose();
          this.#open(item);
        });

        trigger.addEventListener('click', () => {
          if (this.#isOpen(item)) {
            this.#close(item);
          } else {
            this.#open(item);
          }
        });

        content.addEventListener('mouseenter', () => {
          this.#cancelClose();
        });

        item.addEventListener('mouseleave', () => {
          this.#scheduleClose(item);
        });

        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) {
            this.#close(item);
          }
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const activeItem = this.querySelector('[data-desktop-menu-item][open]');
          if (activeItem) {
            this.#closeAll();
            activeItem.querySelector('[data-desktop-menu-trigger]').focus();
          }
        }
      });
    }

    #isOpen(item) {
      return item.hasAttribute('open');
    }

    #open(target) {
      this.menuItems.forEach(item => {
        if (item !== target && this.#isOpen(item)) {
          this.#close(item);
        }
      });
      if (!this.#isOpen(target)) {
        target.setAttribute('open', '');
        target.querySelector('[data-desktop-menu-trigger]').setAttribute('aria-expanded', 'true');
      }
    }

    #close(target) {
      target.removeAttribute('open');
      target.querySelector('[data-desktop-menu-trigger]').setAttribute('aria-expanded', 'false');
    }

    #closeAll() {
      this.#cancelClose();
      this.menuItems.forEach(item => {
        this.#close(item);
      });
    }

    #scheduleClose(target) {
      this.#cancelClose();
      this.#closeTimeout = setTimeout(() => {
        this.#close(target);
      }, 150);
    }

    #cancelClose() {
      if (this.#closeTimeout) {
        clearTimeout(this.#closeTimeout);
        this.#closeTimeout = null;
      }
    }
  });
}
